namespace Ir.Components.Workbook.DrilldownListPopover {

    interface IViewModel {
        config: WorkbookConfig;
        popupConfig: any;
        listConfig: any;
    }

    export function getViewModel(this: IViewModel, params: any) {
        let self = this;
        this.config = params.config as WorkbookConfig;
        let onReportTemplateClick = params.onReportTemplateClick;

        let popoverControl: DevExpress.ui.dxPopover;
        let listTemplateControl: DevExpress.ui.dxList;

        this.listConfig = {
            keyExpr: 'id',
            displayExpr(e: Drilldown) {
                return replaceBasicHtmlContent(e?.name);
            },
            searchEnabled: true,
            searchExpr: 'name',
            pageLoadMode: 'scrollBottom',
            onInitialized(e) {
                listTemplateControl = e.component;
            },
            onItemClick(e) {
                onReportTemplateClick(e.itemData);
                popoverControl.hide();
            }
        };

        let drilldownListToDisable: Array<Drilldown>;

        this.popupConfig = {
            width: 380,
            height: 400,
            showTitle: true,
            title: 'Report Templates',
            visible: false,
            hideOnOutsideClick: true,
            showCloseButton: true,
            onShowing(e) {
                loadDrilldown(drilldownListToDisable, listTemplateControl);
            },
            onInitialized(e) {
                popoverControl = e.component;
                if (params.callback && typeof params.callback === "function") {
                    params.callback({
                        show(element, drilldownList: Array<Drilldown>) {
                            drilldownListToDisable = drilldownList;
                            popoverControl.show(element);
                        }
                    });
                }
            },
            toolbarItems: [{
                widget: "dxButton",
                location: "after",
                options: {
                    icon: "ms ir-sort-by-alpha-icon",
                    hint: "Sort alphabetically",
                    elementAttr: {
                        class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
                    },
                    onClick(e) {
                        loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                        if (e.element.hasClass("selected")) {
                            e.element.removeClass("selected");
                        }
                        else {
                            e.element.addClass("selected");
                        }

                        loadDrilldown(drilldownListToDisable, listTemplateControl);
                    }
                }
            }]
        };
    }

    function loadDrilldown(drilldownListToDisable: Array<Drilldown>, listTemplateControl) {
        let reportTemplateList = createInstances(Drilldown, workbook.workbookConfig.reportTemplateList()).sort(MappingService.sortFields);
        for (let reportTemplate of reportTemplateList) {
            if (drilldownListToDisable.find(x => x.id == reportTemplate.id)) {
                reportTemplate.disabled(true);
            }
        }
        listTemplateControl.option("dataSource", reportTemplateList);
    }
}